import React, { useState } from "react";
import { Tab, Button } from "semantic-ui-react";
import { BasicModal } from "../../../components/Shared";
import {
  SceneList,
  MultiStepForm,
} from "../../../components/Admin/VirtualScenes";
import "./VirtualScenes.scss";

export function VirtualScenes() {
  const [showModal, setShowModal] = useState(false); // Estado para mostrar/ocultar el modal
  const [reload, setReload] = useState(false); // Estado para forzar la recarga de la lista de escenas

  const onOpenCloseModal = () => setShowModal((prevState) => !prevState); // Función para abrir/cerrar el modal
  const onReload = () => setReload((prevState) => !prevState); // Función para forzar la recarga de las escenas
  //
  const panes = [
    {
      render: () => (
        <Tab.Pane attached={false}>
          <SceneList reload={reload} onReload={onReload} />
        </Tab.Pane>
      ),
    },
  ];

  return (
    <>
      <div className="virtual-scenes-page">
        <div className="virtual-scenes-page__add">
          {/* Botón para abrir el formulario de nueva escena */}
          <Button primary onClick={onOpenCloseModal}>
            Nueva Escena Virtual
          </Button>
        </div>

        {/* Pestañas para mostrar las escenas */}
        <Tab menu={{ secondary: true }} panes={panes} />
      </div>

      {/* Modal para crear/editar una escena */}
      <BasicModal
        show={showModal}
        close={onOpenCloseModal}
        title="Crear nueva escena virtual"
      >
        <MultiStepForm onClose={onOpenCloseModal} onReload={onReload} />
      </BasicModal>
    </>
  );
}
